import { jsx, jsxs } from "react/jsx-runtime";
import ReactDOM from "react-dom";
const ConfirmActionDialog = ({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel
}) => {
  if (!open) {
    return null;
  }
  return ReactDOM.createPortal(
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "tw:fixed tw:inset-0 tw:z-[10000] tw:flex tw:items-center tw:justify-center tw:bg-black/45 tw:px-4",
        onClick: onCancel,
        children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: "tw:w-full tw:max-w-md tw:rounded-xl tw:bg-white tw:p-5 tw:shadow-2xl",
            onClick: (event) => event.stopPropagation(),
            children: [
              /* @__PURE__ */ jsx("h3", { className: "tw:text-base tw:font-semibold tw:text-gray-900", children: title }),
              /* @__PURE__ */ jsx("p", { className: "tw:mt-2 tw:text-sm tw:text-gray-600", children: message }),
              /* @__PURE__ */ jsxs("div", { className: "tw:mt-5 tw:flex tw:justify-end tw:gap-2", children: [
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    type: "button",
                    onClick: onCancel,
                    className: "tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:px-3 tw:py-2 tw:text-sm tw:font-medium tw:text-gray-700 hover:tw:bg-gray-50",
                    children: cancelText
                  }
                ),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    type: "button",
                    onClick: onConfirm,
                    className: "tw:rounded-md tw:bg-primary tw:px-3 tw:py-2 tw:text-sm tw:font-medium tw:text-white hover:tw:opacity-90",
                    children: confirmText
                  }
                )
              ] })
            ]
          }
        )
      }
    ),
    document.body
  );
};
export {
  ConfirmActionDialog
};
//# sourceMappingURL=ConfirmActionDialog.js.map
